import AppVariables from "../../common/AppVariables";
import Crops from "../../views/Farmers/Crops";

const farmerCrops = AppVariables.Crops.length > 0 ? AppVariables.Crops : Crops;

/**
 * Get all farmer crops synchronous
 * @returns {Array}
 */
export const getCrops = () => farmerCrops;

/**
 * Get all farmer crops asynchronous
 * @returns {Promise<Array>}
 */
export const getCropsAsync = () => Promise.resolve(farmerCrops);


// WEBPACK FOOTER //
// ./src/data/crops/index.js